export const ImageObjectId = 'Image';

export enum ImageObjectAttributes {
  BLOB = 'blob',
  TAGS = 'tags',
  ALTERNATIVE_TEXT = 'alternativeText',
  TITLE = 'title',
  VISIBLE_IN_SEARCH = 'visibleInSearch',
}
